import RatingsWrapper from "./RatingsWrapper";

export default RatingsWrapper;